import { render, staticRenderFns } from "./bidDetails.vue?vue&type=template&id=e10aa756&scoped=true&"
import script from "./bidDetails.vue?vue&type=script&lang=js&"
export * from "./bidDetails.vue?vue&type=script&lang=js&"
import style0 from "./bidDetails.vue?vue&type=style&index=0&id=e10aa756&prod&scoped=true&lang=css&"
import style1 from "./bidDetails.vue?vue&type=style&index=1&id=e10aa756&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10aa756",
  null
  
)

export default component.exports